import { LEVEL_VALUES, SCENARIO_TYPE_VALUES } from 'containers/AwarenessCenter/constants'

import {
  ADD_SCENARIO_ASYNC,
  CHANGE_SCENARIO_CONTENT,
  CHANGE_SCENARIO_LANG_VALUES,
  CHANGE_SCENARIO_PROPERTY,
  CREATE_CAMPAIGN_FROM_INCIDENTS_ASYNC,
  CREATE_CAMPAIGN_FROM_SCENARIO_ASYNC,
  DEFAULT_SCENARIO_CONTENT,
  GET_AWARENESS_DETAILS_ASYNC,
  GET_SCENARIO_ASYNC,
  REPORT_TO_TEMPLATE_ASYNC,
  RESET_MANAGER,
  SAVE_SCENARIO_ASYNC,
  SET_SCENARIO_WAS_LOADER,
} from './constants'

export const DEFAULT_SCENARIO = {
  scenario_group: null,
  name: '',
  landing_page: null,
  template_path: '',
  type: SCENARIO_TYPE_VALUES.DRIVE_BY,
  filetype: 1,
  level: LEVEL_VALUES.EXPERT_LEVEL,
  is_system: false,
  is_community_candidate: false,
  locale: 1,
  contents: [],
  previewLangValues: [],
}

const initialState = {
  error: null,
  saveLoader: false,
  getDetailsLoader: false,
  getScenarioLoader: false,
  createCampaignLoader: false,
  scenario: DEFAULT_SCENARIO,
  scenarioLangValues: [],
  details: {},
  createdCampaignId: null,
  scenarioWasLoaded: false,
  isDefaultTabValid: true,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case RESET_MANAGER:
      return {
        ...initialState,
      }
    case GET_SCENARIO_ASYNC.INITIATE:
      return {
        ...state,
        getScenarioLoader: true,
      }
    case GET_SCENARIO_ASYNC.SUCCESS:
      const isDefaultTabValid = !!(
        action.payload.scenario.contents.findIndex(
          ({ locale }) => locale === action.payload.defaultLanguage.id
        ) + 1
      )
      const contents = action.payload.scenario.contents
        .map((content) => ({
          ...content,
          from_email: content.from_email ? content.from_email : '',
        }))
        .sort((a) => {
          if (a.value === action.payload.defaultLanguage.id) return -1
          else return 0
        })

      return {
        ...state,
        getScenarioLoader: false,
        error: null,
        scenarioWasLoaded: false,
        scenario: {
          ...action.payload.scenario,
          previewLangValues: action.payload.scenario.contents.map(({ locale }) => locale),
          contents,
        },
        isDefaultTabValid,
      }
    case GET_SCENARIO_ASYNC.ERROR:
      return {
        ...state,
        error: action.error.response,
        getScenarioLoader: false,
      }
    case ADD_SCENARIO_ASYNC.INITIATE:
      return {
        ...state,
        saveLoader: true,
        error: null,
      }
    case ADD_SCENARIO_ASYNC.SUCCESS:
      return {
        ...state,
        saveLoader: false,
        error: null,
        scenario: action.payload.scenario,
      }
    case ADD_SCENARIO_ASYNC.ERROR:
      return {
        ...state,
        saveLoader: false,
        error: action.error.response,
      }
    case SAVE_SCENARIO_ASYNC.INITIATE:
      return {
        ...state,
        saveLoader: true,
        error: null,
      }
    case SAVE_SCENARIO_ASYNC.SUCCESS:
      return {
        ...state,
        error: null,
        saveLoader: false,
        scenario: {
          ...state.scenario,
          ...action.payload.data,
        },
      }
    case SAVE_SCENARIO_ASYNC.CANCEL:
      return {
        ...state,
        saveLoader: false,
      }
    case GET_AWARENESS_DETAILS_ASYNC.INITIATE:
      return {
        ...state,
        getDetailsLoader: true,
      }
    case GET_AWARENESS_DETAILS_ASYNC.SUCCESS:
      return {
        ...state,
        getDetailsLoader: false,
        details: action.payload.data,
      }
    case GET_AWARENESS_DETAILS_ASYNC.ERROR:
    case GET_AWARENESS_DETAILS_ASYNC.CANCEL:
      return {
        ...state,
        getDetailsLoader: false,
      }
    case CHANGE_SCENARIO_PROPERTY:
      return {
        ...state,
        scenario: {
          ...state.scenario,
          [action.payload.propertyName]: action.payload.value,
        },
      }
    case CHANGE_SCENARIO_CONTENT:
      const newContents = [...state.scenario.contents]

      newContents[action.payload.contentIndex] = action.payload.content

      return {
        ...state,
        scenario: {
          ...state.scenario,
          contents: newContents,
        },
      }
    case SAVE_SCENARIO_ASYNC.ERROR:
      return {
        ...state,
        error: action.error.response,
        saveLoader: false,
      }
    case REPORT_TO_TEMPLATE_ASYNC.INITIATE:
      return {
        ...state,
        getScenarioLoader: true,
        error: null,
      }
    case REPORT_TO_TEMPLATE_ASYNC.SUCCESS:
      const scenario = {
        ...DEFAULT_SCENARIO,
        ...action.payload.scenario,
        contents: [
          {
            ...DEFAULT_SCENARIO_CONTENT,
            ...action.payload.scenario.contents[0],
          },
        ],
      }

      if (action.payload.scenario.contents[0].attachment_data) {
        scenario.contents[0].filename = action.payload.scenario.contents[0].attachment_data.filename
        scenario.filetype = action.payload.scenario.contents[0].attachment_data.filetype
      }

      return {
        ...state,
        getScenarioLoader: false,
        error: null,
        scenario,
      }
    case REPORT_TO_TEMPLATE_ASYNC.ERROR:
      return {
        ...state,
        getScenarioLoader: false,
        error: action.error.response,
      }
    case CREATE_CAMPAIGN_FROM_INCIDENTS_ASYNC.INITIATE:
      return {
        ...state,
        createCampaignLoader: true,
        createdCampaignId: null,
        error: null,
      }
    case CREATE_CAMPAIGN_FROM_INCIDENTS_ASYNC.SUCCESS:
      return {
        ...state,
        createdCampaignId: action.payload.id,
        createCampaignLoader: false,
      }
    case CREATE_CAMPAIGN_FROM_INCIDENTS_ASYNC.ERROR:
      return {
        ...state,
        createCampaignLoader: false,
        error: action.error,
      }
    case CREATE_CAMPAIGN_FROM_SCENARIO_ASYNC.INITIATE:
      return {
        ...state,
        createdCampaignId: null,
        createCampaignLoader: true,
      }
    case CREATE_CAMPAIGN_FROM_SCENARIO_ASYNC.SUCCESS:
      return {
        ...state,
        createdCampaignId: action.payload.id,
        createCampaignLoader: false,
      }
    case CREATE_CAMPAIGN_FROM_SCENARIO_ASYNC.ERROR:
      return {
        ...state,
        error: action.error.response,
        createCampaignLoader: false,
      }
    case CHANGE_SCENARIO_LANG_VALUES:
      return {
        ...state,
        scenarioLangValues: action.payload.scenarioLangValues,
      }
    case SET_SCENARIO_WAS_LOADER:
      return {
        ...state,
        scenarioWasLoaded: action.payload.value,
      }

    default:
      return state
  }
}
